export default __webpack_public_path__ + "static/media/maritime.7addc31b.jpg";